export default __webpack_public_path__ + "static/media/send-icon.bd84c639.svg";